export const parseToken = (token) => {
    try {
        const payload = token.split('.')[1];
        const parsedToken = JSON.parse(atob(payload));
        if (!parsedToken.cko_entity_segments) {
            parsedToken.cko_entity_segments = {}; // to maintain backwards compatibility we set this to an empty array if we have the old token.
        }
        return parsedToken;
    }
    catch {
        return {};
    }
};
